import DashboardNotificationsCard from "./DashboardNotificationsCard"
import DashboardWatchlistCard from "./DashboardWatchlistCard"

// The home dashboard's notifications and watchlist cards, as the right-hand
// column of the Community sub-pages (Checker, Convoy).
export default function CommunityActivityColumn() {
    return (
        <aside className="checker-aside">
            <DashboardNotificationsCard />
            <DashboardWatchlistCard />
        </aside>
    )
}
